import * as React from "react";
import { WithStyles, withStyles, Theme, createStyles, ListItem, ListItemText } from "@material-ui/core";
import { NavLink } from "react-router-dom";

interface VideoListItemProps extends WithStyles<typeof styles> {
  title: string;
  path: string;
}

class VideoListItem extends React.PureComponent<VideoListItemProps> {
  static muiName = "ListItem";

  render() {
    const { title, path, classes, ...rest } = this.props;
    return (
      <NavLink className={classes.root} to={`/help/${path}/${title}`}>
        <ListItem {...rest} button={true} className={classes.listItem}>
          <ListItemText primaryTypographyProps={{ classes: { root: classes.text } }} primary={title} />
        </ListItem>
      </NavLink>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      textDecoration: "none",
      color: theme.palette.text.primary
    },
    listItem: {
      padding: "0.25rem 0 0.25rem 0.5rem"
    },
    text: {
      ".active &": {
        borderBottom: `3px solid ${theme.palette.primary.light}`,
        marginBottom: -3
      }
    }
  });

export default withStyles(styles)(VideoListItem);
